import { render, staticRenderFns } from "./TypographySkeleton.vue?vue&type=template&id=de304106&scoped=true&"
import script from "./TypographySkeleton.vue?vue&type=script&lang=js&"
export * from "./TypographySkeleton.vue?vue&type=script&lang=js&"
import style0 from "./TypographySkeleton.vue?vue&type=style&index=0&id=de304106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de304106",
  null
  
)

export default component.exports